import { Component, OnInit, Inject, forwardRef } from '@angular/core';
import { AppComponent } from '../app.component';

@Component({
  selector: 'right-jacket',
  templateUrl: './right-jacket.component.html',
  styleUrls: ['./right-jacket.component.css']
})
export class RightJacketComponent implements OnInit {

   constructor(@Inject(forwardRef(() => AppComponent)) public parent : AppComponent) {
   }
  
  ngOnInit() {
    this.parent.applyDesignOnJacket();
  }

}



// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/app/right-jacket/right-jacket.component.ts